import { connect } from "react-redux";
import RSVPFrom from "../../RSVPFrom/RSVPFrom";
import Dholak from "../Dholak";
import Reveal from "../Reveal";
import Section from "./Section";
import { isRsvpEnabled } from "../../../utils";

/**
 * RSVP: the shared RSVPFrom (same fields, validation and API call), styled for the
 * theme, and below it a dholak pair the guest can play (Dholak.js).
 */
const Rsvp = ({ rsvpConfigs, events }) => {
  if (!isRsvpEnabled(rsvpConfigs)) return null;

  return (
    <Section
      id="rsvp"
      className="ut-rsvp"
      label="RSVP"
      deco={["latkans", "petals", "butterflies"]}
      seed={88}
      tone="haldi"
      kicker="Kindly Respond"
      lead="Your gracious presence is sincerely requested"
    >
      <Reveal className="ut-form" delay={0.1}>
        <RSVPFrom rsvpConfigs={rsvpConfigs} events={events} />
      </Reveal>
      <Reveal effect="zoom" delay={0.15}>
        <Dholak />
      </Reveal>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  rsvpConfigs: state.inviteDetails.invite?.rsvpConfigs,
  events: state.inviteDetails.invite?.events,
});

export default connect(mapStateToProps)(Rsvp);
